import {CLICK_ENERGY, VIBRATE_TIME} from '../../../ClickerGame.constants';
import {DI_TOKENS} from '@/di/di.tokens';
import {FederatedPointerEvent} from 'pixi.js';

import {injected} from 'brandi';

import {BaseComponent, IGameWorld} from '@specials/gcs-engine';

import {GameOperationsService} from '@/services/shared/GameOperationsService/GameOperationsService';
import {ClickerStateStore} from '@/stores/ClickerStateStore/ClickerStateStore';
import {Vibration} from '@/utils/Vibration';

import {ClickerAudioPlayer, ClickerSoundsBundle} from '../../../ClickerAudioPlayer';
import {ClickerGameEventNames, ClickerGameEvents} from '../../../ClickerGameEvents';
import {WaveEmitterComponent} from '../../../components/WaveEmitterComponent/WaveEmitterComponent';
import {PointsEmitter} from '../../PointsEmitterPool/PointsEmitter';
import {BackgroundGalaxyViewComponent} from './BackgroundGalaxyViewComponent';

export class BackgroundGalaxyInteractivityComponent extends BaseComponent {
  private pointsEmitter?: PointsEmitter;
  private waveEmitterComponent?: WaveEmitterComponent;
  private viewComponent?: BackgroundGalaxyViewComponent;

  constructor(
    private readonly gameOperationsService: GameOperationsService,
    private readonly clickerStateStore: ClickerStateStore,
    private readonly audioPlayer: ClickerAudioPlayer,
    private readonly clickerEvents: ClickerGameEvents,
    private readonly vibration: Vibration,
  ) {
    super();
  }

  public onAddToWorld(world: IGameWorld): void {
    super.onAddToWorld(world);

    this.viewComponent = this.gameObject.getComponent(BackgroundGalaxyViewComponent)!;
    this.waveEmitterComponent = this.gameObject.getComponent(WaveEmitterComponent);

    this.pointsEmitter = world.getGameObject(PointsEmitter);

    const view = this.viewComponent?.view;

    if (!view) throw new Error('View is not exist');

    view.cursor = 'pointer';
    view.eventMode = 'static';

    view.on('pointerdown', this.handleClick);
  }

  public destroy(): void {
    this.viewComponent?.view.off('pointerdown', this.handleClick);
  }

  private handleClick = (e: FederatedPointerEvent): void => {
    if (!this.clickerStateStore.isEnoughEnergyToSpend(CLICK_ENERGY) || e.target !== this.viewComponent?.view) {
      this.clickerEvents.emitEvent(ClickerGameEventNames.AnyTap);

      return;
    }

    this.gameOperationsService.pushSpendEnergyOperation(CLICK_ENERGY);

    const points = this.clickerStateStore.getPointsByEnergy(CLICK_ENERGY);
    const pos = e.screen;
    // эмиттеры находятся на разных слоях, нижний это волны, верхний очки
    this.pointsEmitter?.emitterComponent.spawnPoints(points, pos);
    this.waveEmitterComponent?.emitWave(pos);

    this.audioPlayer.playClickSound(ClickerSoundsBundle.Tap);
    this.clickerEvents.emitEvent(ClickerGameEventNames.Tap);
    this.clickerEvents.emitEvent(ClickerGameEventNames.AnyTap);

    this.vibration.vibrate(VIBRATE_TIME);
  };
}

injected(
  BackgroundGalaxyInteractivityComponent,
  DI_TOKENS.gameOperationsService,
  DI_TOKENS.clickerStateStore,
  DI_TOKENS.clickerGameAudioPlayer,
  DI_TOKENS.clickerGameEvents,
  DI_TOKENS.vibration,
);
